import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { BillingProvider } from "@/context/BillingContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Builder from "@/pages/Builder";
import ProjectDetail from "@/pages/ProjectDetail";
import Profile from "@/pages/Profile";
import Billing from "@/pages/Billing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Generate from "@/pages/Generate";
import Features from "@/pages/Features";
import HowItWorks from "@/pages/HowItWorks";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import PublicPricing from "@/pages/PublicPricing";
import Admin from "@/pages/Admin";
import SharePage from "@/pages/SharePage";
import HomeImprovement from "@/pages/HomeImprovement";
import TenantImprovement from "@/pages/TenantImprovement";
import Forum from "@/pages/Forum";
import ForumThread from "@/pages/ForumThread";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import QuoteReply from "@/pages/QuoteReply";
import Contractors from "@/pages/Contractors";
import ContractorApply from "@/pages/ContractorApply";
import Brand from "@/pages/Brand";

function AppRouter() {
  const location = useLocation();
  // Handle Google OAuth return before anything else (session_id in URL fragment).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/generate" element={<Generate />} />
      <Route path="/features" element={<Features />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/pricing" element={<PublicPricing />} />
      <Route path="/home-improvement" element={<HomeImprovement />} />
      <Route path="/tenant-improvement" element={<TenantImprovement />} />
      <Route path="/forum" element={<Forum />} />
      <Route path="/forum/:id" element={<ForumThread />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/quote/:token" element={<QuoteReply />} />
      <Route path="/contractors" element={<Contractors />} />
      <Route path="/brand" element={<Brand />} />
      <Route
        path="/contractors/apply"
        element={
          <ProtectedRoute>
            <ContractorApply />
          </ProtectedRoute>
        }
      />
      <Route path="/share/:id" element={<SharePage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/builder"
        element={
          <ProtectedRoute>
            <Builder />
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects/:id"
        element={
          <ProtectedRoute>
            <ProjectDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/billing"
        element={
          <ProtectedRoute>
            <Billing />
          </ProtectedRoute>
        }
      />
      <Route
        path="/payment/success"
        element={
          <ProtectedRoute>
            <PaymentSuccess />
          </ProtectedRoute>
        }
      />
      <Route path="/payment/cancel" element={<Navigate to="/billing" replace />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BillingProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster position="bottom-right" theme="dark" />
        </BillingProvider>
      </AuthProvider>
    </div>
  );
}
